import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { ProductTypeStockProperty1 } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ProductTypeStockProperty1Service extends TmsWebBaseEditCreateService<
  ProductTypeStockProperty1,
  ProductTypeStockProperty1
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('ProductTypeStockProperty1', $localize`Product Type Stock Property`);
  }

  getForProductType(id: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForProductTypeStockProperty1/${id}`);
  }

  getForProductTypeAndStockPropertyHeader(
    productTypeId: string,
    stockPropertyHeader: string,
  ): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(
      `${this.apiUrl}/GetForProductTypeAndStockPropertyHeader?productTypeId=${productTypeId}&stockPropertyHeader=${stockPropertyHeader}`,
    );
  }

  getAllStockProperty1sForProductTypes(productTypeId: string): Observable<ProductTypeStockProperty1[]> {
    return this.httpService.get<ProductTypeStockProperty1[]>(`${this.apiUrl}/GetAllStockProperty1S/${productTypeId}`);
  }

  getAllStockPropertyHeadersForProductType(productType: string): Observable<ProductTypeStockProperty1[]> {
    return this.httpService.get<ProductTypeStockProperty1[]>(
      `${this.apiUrl}/GetAllStockPropertyHeaders?productType=${productType}`,
    );
  }

  updateStockProperty1sProductTypes(productTypeId: string, StockProperty1Ids: string[]): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/UpdateStockProperty1SProductTypes`, {
      productTypeId,
      StockProperty1Ids,
    });
  }
}
